import { IconPropsType } from './types/IconsProps.type';

type DocumentIconProps = IconPropsType & {
  strokeColor?: string;
};

export const DocumentIcon = ({
  width = 20,
  height = 20,
  className = '',
  style = {},
  fillColor = 'none',
  strokeColor = 'currentColor',
}: DocumentIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M4.35137 2.97613H12.6848M4.35137 4.75934H12.6848M4.35137 6.39033H12.6848M4.35137 8.06481H12.6848M4.35137 9.78279H12.6848M6.37842 16.8036L6.66287 17.5664C6.75995 17.8267 7.01374 18 7.29789 18H13.0424C13.4325 18 13.745 17.6782 13.7631 17.2983C13.8005 16.5124 13.9788 15.2853 14.6994 14.8023C15.2523 14.4318 16.1518 14.4809 16.8281 14.5932C17.2809 14.6684 17.7333 14.3424 17.7333 13.8946V4.46181C17.7333 4.40931 17.727 4.35699 17.7121 4.30657C17.6619 4.13774 17.5242 3.73163 17.3095 3.53443C16.7768 3.04516 15.5025 3.22989 15.5025 3.22989M11.047 12.4028C10.46 13.0382 10.384 14.1866 10.408 14.9491C10.4207 15.3517 10.0989 15.7112 9.68565 15.7112H3.67568C3.30251 15.7112 3 15.4163 3 15.0525V1.65871C3 1.29491 3.30251 1 3.67568 1L13.2312 1C13.5955 1 13.8943 1.28158 13.9065 1.63656L14.2302 11.014C14.2456 11.4605 13.8055 11.8041 13.3489 11.7658C12.6231 11.705 11.6351 11.7661 11.047 12.4028ZM11.3628 14.8413C11.33 14.2009 11.4054 13.4567 11.8439 13.0621C12.2509 12.6959 12.9555 12.6445 13.5628 12.6859C14.0779 12.7209 14.2523 13.3085 13.8898 13.6669L12.3747 15.1651C12.0049 15.5308 11.3891 15.3543 11.3628 14.8413ZM15.7324 17.7092L17.2678 16.1705C17.6319 15.8055 17.4448 15.2135 16.9231 15.1924C16.3148 15.1677 15.6155 15.2377 15.2125 15.6072C14.7788 16.0048 14.6948 16.743 14.7194 17.3825C14.7394 17.9008 15.3614 18.081 15.7324 17.7092Z"
        stroke={strokeColor}
      />
    </svg>
  );
};
